<template>
    <v-container fluid>
        <!-- Breadcrumbs -->
        <v-breadcrumbs
            :items="[
                { text: 'Home', disable: false, href: '/#/' },
                { text: 'Inventory By Week', disabled: true }
            ]"
            divider="/"
        ></v-breadcrumbs>

        <v-row class="ma-0">
            <v-col cols="12" class="pt-0">
                <v-hover>
                    <template v-slot="{ hover }">
                        <v-card :elevation="hover ? 6 : 1">
                            <v-card-title class="pb-0">
                                <v-icon color="primary" class="ml-2 mr-2"
                                    >extension</v-icon
                                >Inventory by week
                                <v-spacer></v-spacer>
                            </v-card-title>

                            <v-container fluid>
                                <v-data-table
                                    :headers="headers"
                                    :loading="
                                        $apollo.queries
                                            .tenantPlantInventoryByWeekSum
                                            .loading
                                    "
                                    :items="tenantPlantInventoryByWeekSum.edges"
                                    :options.sync="dataTableOptions"
                                    :server-items-length="
                                        tenantPlantInventoryByWeekSum.totalCount
                                    "
                                    loading-text="Loading... Please wait"
                                    :items-per-page="defaultItemsPerPage"
                                    hide-default-footer
                                >
                                    <template
                                        v-slot:item.node.readySalesWeekStartDate="{
                                            item
                                        }"
                                    >
                                        <span
                                            >{{
                                                item.node
                                                    .readySalesWeekStartDate
                                                    | moment("YYYY-[W]WW")
                                            }}
                                        </span>
                                    </template>

                                    <template
                                        v-slot:item.node.readySalesInventory="{
                                            item
                                        }"
                                    >
                                        <span class="mr-5"
                                            >{{ item.node.readySalesInventory }}
                                        </span>
                                    </template>

                                    <template
                                        v-slot:item.node.orderedInventory="{
                                            item
                                        }"
                                    >
                                        <v-icon
                                            color="warning"
                                            small
                                            left
                                            v-if="
                                                item.node
                                                    .notEnoughInventoryAlert
                                            "
                                            >warning</v-icon
                                        >
                                        <span class="mr-5"
                                            >{{ item.node.orderedInventory }}
                                        </span>
                                    </template>

                                    <template v-slot:item.action="{ item }">
                                        <!-- <v-btn
                                            outlined
                                            rounded
                                            small
                                            color="primary"
                                            @click="openPlantDialog(item.node)"
                                        >View</v-btn>-->
                                        <v-btn
                                            icon
                                            color="primary"
                                            @click="
                                                goToSelectedWeek(
                                                    item.node.readySalesYearWeek
                                                )
                                            "
                                        >
                                            <v-icon>remove_red_eye</v-icon>
                                        </v-btn>
                                        <!-- <v-icon small @click="deletingPlant(item)">delete</v-icon> -->
                                    </template>
                                </v-data-table>
                            </v-container>
                        </v-card>
                    </template>
                </v-hover>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import gql from "graphql-tag";
// import moment from "moment";

export default {
    name: "inventory-by-week-sum",
    components: {},

    apollo: {
        tenantPlantInventoryByWeekSum: {
            query: gql`
                query tenantPlantInventoryByWeekSum(
                    $first: Int
                    $last: Int
                    $before: String
                    $after: String
                    $orderBy: String
                ) {
                    tenantPlantInventoryByWeekSum(
                        first: $first
                        last: $last
                        before: $before
                        after: $after
                        orderBy: $orderBy
                    ) {
                        edgeCount
                        totalCount
                        pageInfo {
                            startCursor
                            endCursor
                            hasPreviousPage
                            hasNextPage
                        }
                        edges {
                            node {
                                id
                                readySalesWeekStartDate
                                readySalesYearWeek
                                readySalesInventory
                                orderedInventory
                                notEnoughInventoryAlert
                            }
                        }
                    }
                }
            `,
            variables() {
                return {
                    first: 10,
                    orderBy: "readySalesYearWeek"
                };
            },
            // Additional options here
            fetchPolicy: "cache-and-network",
            update: data => data.tenantPlantInventoryByWeekSum,
            skip: true,
            pollInterval: 60000 // ms
        }
    },

    data: function() {
        return {
            isLoadingInventory: false,

            defaultItemsPerPage: 100,
            dataTableOptions: {},
            page: 1,

            tenantPlantInventoryByWeekSum: {},

            headers: [
                {
                    text: "Week",
                    value: "node.readySalesWeekStartDate",
                    sortable: true
                },
                {
                    text: "Ready For Sale",
                    value: "node.readySalesInventory",
                    align: "right",
                    sortable: true
                },
                {
                    text: "Ordered",
                    value: "node.orderedInventory",
                    align: "right",
                    sortable: true
                },
                {
                    text: "Actions",
                    value: "action",
                    width: "120px",
                    align: "center",
                    sortable: false
                }
            ],
            editedIndex: -1
        };
    },
    computed: {
        // inventory: function() {
        //     return this.$store.state.inventory.inventory;
        // }
    },
    watch: {
        dataTableOptions: {
            handler() {
                this.refreshCurrentPage();
            },
            deep: true
        }
    },
    created() {
        this.initialize();
    },
    methods: {
        initialize() {
            // this.fetchInventory();
        },

        refreshCurrentPage() {
            const {
                sortBy,
                sortDesc,
                page,
                itemsPerPage
            } = this.dataTableOptions;

            // console.log(sortBy, sortDesc, page, itemsPerPage);

            var _first = itemsPerPage;
            var _last = null;
            var _before = null;
            var _after = null;
            var _orderBy = null;

            if (page < this.page) {
                _first = null;
                _last = itemsPerPage;
                _before = this.tenantPlantInventoryByWeekSum.pageInfo
                    .startCursor;
                _after = null;
            }

            if (page > this.page) {
                _first = itemsPerPage;
                _last = null;
                _before = null;
                _after = this.tenantPlantInventoryByWeekSum.pageInfo.endCursor;
            }

            switch (sortBy[0]) {
                case "node.readySalesWeekStartDate":
                    _orderBy = "readySalesWeekStartDate";
                    break;
                case "node.readySalesYearWeek":
                    _orderBy = "readySalesYearWeek";
                    break;
                case "node.readySalesInventory":
                    _orderBy = "readySalesInventory";
                    break;
                case "node.orderedInventory":
                    _orderBy = "orderedInventory";
                    break;
                case "node.notEnoughInventoryAlert":
                    _orderBy = "notEnoughInventoryAlert";
                    break;
                default:
                    _orderBy = null;
                    break;
            }

            if (sortDesc[0] === true) {
                _orderBy = "-" + _orderBy;
            }

            this.$apollo.queries.tenantPlantInventoryByWeekSum.setVariables({
                first: _first,
                last: _last,
                before: _before,
                after: _after,
                orderBy: _orderBy
            });

            // set skip false to execute the query
            this.$apollo.queries.tenantPlantInventoryByWeekSum.skip = false;
            this.$apollo.queries.tenantPlantInventoryByWeekSum.refresh();

            // update this.page
            this.page = page;
        },

        goToSelectedWeek(yearWeek) {
            this.$router.push({
                name: "inventory-by-week",
                params: {
                    yearWeek: yearWeek
                }
            });
        }
    }
};
</script>